import { render, staticRenderFns } from "./edit-tags-modal.vue?vue&type=template&id=32315019&scoped=true&"
import script from "./edit-tags-modal.vue?vue&type=script&lang=js&"
export * from "./edit-tags-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-tags-modal.vue?vue&type=style&index=0&id=32315019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32315019",
  null
  
)

export default component.exports